<template>
    <div>
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        offset-y
        :nudge-width="300"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            tile
            :ripple="false"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon small>
              mdi-tag-plus
            </v-icon>
          </v-btn>
        </template>
  
        <v-card class="pa-3">
          <v-autocomplete 
            :label="$t('appointmentDashboard.tag.tags')"
            :items="tags"
            v-model="selectedTags"
            item-value="id"
            item-text="name"
            multiple
            outlined
            deletable-chips
            small-chips
          />  
  
          <v-card-actions>
            <v-btn
              elevation="0"
              text
              :isLoading="isLoading"
              @click="closeMenu()"
            >
              {{ $t('appointmentDashboard.tag.cancel') }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              elevation="0"
              :isLoading="isLoading"
              @click="addTags()"
            >
              {{ $t('appointmentDashboard.tag.add') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from 'vuex';
  
  export default {
    name: 'BoardTagsMenu',  
  
    data: () => {
      return {
        menu: false,
        selectedTags: null
      }
    },
  
    computed: {
      ...mapGetters(['tags', 'isLoading'])
    },
  
    methods: {
      ...mapActions(['addTagsToAppointment']),
  
      closeMenu() {
        this.menu = false
        this.selectedTags = null
      },
  
      async addTags() {
        const body = {
          appointment_id: this.$parent.appointment.id,
          tags_ids: this.selectedTags
        }
  
        await this.addTagsToAppointment(body)
        this.closeMenu()
      }
    },
  
    mounted() {
      this.$root.$on('changeActiveBoardLine', () => {
        this.closeMenu()
      })
      this.$root.$on('showAppointmentBoardLine', () => {
        this.closeMenu()
      })
    }
  }
  </script>